import { extensions } from '@yola/ws-sdk';
import constants from '../constants';

const getGdprCheckboxQuerySelector = () => {
  const { gdprConsentField } = extensions.accessors.getExtensionSettings(constants.common.slug);
  return gdprConsentField.querySelector;
};

export default getGdprCheckboxQuerySelector;
